
























import { defineComponent } from '@vue/composition-api';
import {
    SdsButton,
    SdsIllustration,
} from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    emits: [
        'close',
    ],
    props: {
        amount: {
            type: Number,
            required: true,
        },
    },
    setup(_props, { emit }) {
        return {
            onCloseClick: () => {
                emit('close');
            },
        };
    },
    components: {
        SdsButton,
        SdsIllustration,
    },
});
